import { STATUS_TYPE } from '../../../enum';

export interface FindPayment {
  advertiseId?: string;
  packageId?: string;
  paymentStatus?: string;
  search?: string;
  limit?: number;
  skip?: number;
}

export interface Payment {
  id: string;
  advertiseNumber: string;
  title: string;
  description: string;
  zoneNumber: string;
  streetNumber: string;
  buildingNumber: string;
  zipCode: string;
  address: string;
  location: {
    crs: {
      type: string;
      properties: {
        name: string;
      }
    },
    type: string;
    coordinates: any;
  },
  areaPolygon: string;
  price: string;
  startDate: string;
  endDate: string;
  status: string;
  deepLinkUrl: string;
  rejectionReason: string;
  pausedDate: string;
  createdAt: string;
  updatedAt: string;
  locationId: string;
  categoryId: string;
  subCategoryId: string;
  possessionTypeId: string;
  createdBy: string;
  updatedBy: string;
  createdByAdminId: string;
  latitude: number;
  longitude: number;
  isFavourite: boolean;
  createdByUser: {
    id: string;
    name: string;
    userRole: string;
    email: string;
    mobileNumber: string;
    countryCallingCode: string;
  },
  payments: [{
    id: string;
    metadata: string;
    paymentAmount: string;
    paymentStatus: string;
    onlinePaymentId: string;
    paymentDate: string;
    packageId: string;
    advertise_package: {
      id: string;
      labelEn: string;
      labelAr: string;
      duration: number;
    }
  }
  ]

  // id: string;
  // paymentDate: string;
  // metadata: string;
  // paymentAmount: string;
  // paymentStatus: string;
  // onlinePaymentId: string;
  // advertiseId: string;
  // packageId: string;
  // advertise: {
  //   id: string;
  //   title: string;
  //   description: string;
  //   status: string;
  //   advertiseNumber: string;
  // };
  // advertise_package: {
  //   id: string;
  //   labelEn: string;
  //   labelAr: string;
  //   duration: number;
  // };
  // createdByUser: {
  //   id: string;
  //   name: string;
  //   email: string;
  //   countryCallingCode: string;
  //   mobileNumber: string;
  // }
  // createdBy: string;
  // updatedBy: string;
  // updatedAt: string;
  // createdAt: string;
}

interface InitialState {
  data: Payment[];
  skip: number;
  limit: number;
  totalRecords: number;
  currentPage: number;
  status: STATUS_TYPE;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  errorMessage: string;
}

export const initialState: InitialState = {
  data: [],
  skip: 0,
  limit: 25,
  totalRecords: 0,
  currentPage: 0,
  status: 'idle',
  isError: false,
  isLoading: false,
  isSuccess: false,
  errorMessage: '',
};
